"use client";
import Button from "@/components/Button";
import { BUTTON_TEXT } from "../../constant";
import { signIn } from "next-auth/react";
import { useAnalytics } from "@/hooks/useAnalytics";
import { URLS } from "@/constants/constants";

const LoginButton = ({ title }: { title: string }) => {
  const { getDataAttribute } = useAnalytics();

  const handleLogin = async () => {
    await signIn("keycloak", { redirect: false });
  };

  return (
    <Button className="event_button_click" onClick={handleLogin} {...getDataAttribute(BUTTON_TEXT, title, URLS.LOGIN)}>
      {BUTTON_TEXT}
    </Button>
  );
};

LoginButton.displayName = "LoginButton";

export default LoginButton;
